__webpack_require__.p = "/wp-content/plugins/ibj-people/people/dist/";